import $ from 'jquery';

export default function photoGallery() {
    var previous = $().isWelshPage() ? 'Blaenorol' : 'Previous',
        next     = $().isWelshPage() ? 'Nesaf' : 'Next';

    $('.gallery-scroll-image-list').slick({
        prevArrow: `<button class="slick-prev" aria-label="${previous}" type="button">${previous}</button>`,
        nextArrow: `<button class="slick-next" aria-label="${next}" type="button">${next}</button>`,
        speed: 100,
        dots: true,
        dotsClass: 'gallery-options-list',
        arrows: true,
        accessibility: true
    });
}
